import { deleteCartIdFromStorage } from '@maestro/commerce-blocks/session/cart-store'
import { clearWishlistDataFromStorage } from '@maestro/commerce-blocks/session/wishlist-storage'
import { removeProfileUpdateBoxDismissed } from '@maestro/commerce-blocks/utils/profile-update-box.utils'
import { removeAllQueryIdTrackerData } from '@maestro/core/event/queryid-tracker.utils'

export function clearUserStorage(): void {
  deleteCartIdFromStorage()
  clearWishlistDataFromStorage()
  // Clear QueryID tracker on logout
  removeAllQueryIdTrackerData()
  // Clear profile update prompt flag so it can show again on next login
  removeProfileUpdateBoxDismissed()
}
